export default __webpack_public_path__ + "static/media/mission-img.75d92539.webp";